"use client"
import { useSelector } from "react-redux";
import { Box, Text } from "@quintoandar-tokko/jopijs";
import GenericErrorImage from "@/public/images/generic-error.png";
import ImageNext from "@/components/shared/ImageNext";
import BranchSection from "@/components/fichaInfo/propertyDescription/contact/sections/BranchSection";
import { isTrue } from "@/components/fichaInfo/utilities/helpers";
import Trans from "@/components/shared/Trans";
import translations from './calendarClosed.trans.json'
import style from "./calendarClosed.module.scss"

export default function CalendarClosed() {
  const calendar = useSelector(state => state.CalendarSlice)
  const { branch = {} } = calendar
  const isValidBranch = Object.keys(branch).length > 0

  return (
    <Box className={style.calendarClosed}>
      <Box
        as="section"
        className={style.calendarClosedLeftSide}
        data-full-rounded={!isValidBranch}
      >
        <Box className={style.calendarClosedImageWrapper}>
          <ImageNext
            className={style.calendarClosedImage}
            src={GenericErrorImage}
            width="124"
            height="100"
            alt="tokkobroker"
            unoptimized
          />
        </Box>
        <Box as="p" className={style.calendarClosedTitle}>
          {Trans(translations, 'CalendarClosedTitle')}
        </Box>
        <Box as="span" className={style.calendarClosedDescription}>
          {Trans(translations, 'CalendarClosedDescription')}
        </Box>
      </Box>

      {isValidBranch && (
        <Box as="section" className={style.calendarClosedRightSide}>
          <Box className={style.branchWrapper}>
            {isTrue(branch?.logo) && (
              <Box
                as="img"
                src={branch?.logo}
                className={style.branchLogo}
              />
            )}
            <BranchSection
              company_name={branch.company?.name}
              branch_name={branch?.name}
              email={branch?.email}
              phone={branch?.phone}
              contact_time={branch?.contact_time}
              whatsapp={branch?.alt_phone}
              branch_address={branch?.address}
            />
          </Box>
        </Box>
      )}

    </Box>
  );
}
